export const NON_CAMEL_CASED_PROVIDER_PATTERNS = [
    '_mobile_',
    'booking_',
    '_api',
];

export const COMPSET_DEFAULT_MIN_THRESHOLD = 5;
export const COMPSET_DEFAULT_MAX_THRESHOLD = 10;
